import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { formatTimeHMS } from "@helpers";
import { SECTION_ITEM_TYPE } from "@constants";
import styles from "./style/LectureSubItem.module.css";

const LessonItem = (props) => {
  const { title, type, totalTime } = props;
  return (
    <Row className={clsx(styles.container, "py-2")}>
      <Col className={styles.lectureTitle}>
        {type === SECTION_ITEM_TYPE.LECTURE ? (
          <i className="bi bi-play-circle mr-3"></i>
        ) : type === SECTION_ITEM_TYPE.ASSIGNMENT ? (
          <i className="bi bi-file-earmark mr-3"></i>
        ) : (
          <i className="bi bi-lightbulb mr-3"></i>
        )}

        <span>{title}</span>
      </Col>
      {/* <Col xs="auto">
        {isPreview && (
          <button className={clsx(styles.btnPreview, "text-right")}>
            Preview
          </button>
        )}
      </Col> */}
      {type === SECTION_ITEM_TYPE.LECTURE && (
        <Col xs={7} sm={4}>
          <Row>
            <Col className="text-right">{formatTimeHMS(totalTime || 0)}</Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};

/* required: display name */
LessonItem.displayName = "LessonItem";

/* required: props types */
LessonItem.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    SECTION_ITEM_TYPE.ASSIGNMENT,
    SECTION_ITEM_TYPE.LECTURE,
    SECTION_ITEM_TYPE.QUIZ,
  ]),
};

/* required: default props */
LessonItem.defaultProps = { type: SECTION_ITEM_TYPE.LECTURE };

export { LessonItem };
